<div class="w-full h-[100vh] flex justify-center lg:grid lg:grid-cols-[60%_1fr] sm:p-[20px] lg:p-[45px] wrapper-bg">
  <div class="w-full hidden h-full lg:flex flex-col" >
    <div class="w-full hidden h-full md:grid flex-col grid grid-rows-[5%_1fr_5%]">
    <img class="max-w-[180px]" src="../../../assets/icons/secureProxy_white.svg" alt="" />
   <div class="w-full h-full flex justify-center items-end">
   </div>
  </div></div>
 <div class="w-full flex flex-col bg-[#fff] sm:rounded-[20px] sm:max-w-[500px]">
   <img class="max-w-[130px] ms-[40px] mt-[40px] lg:hidden flex " src="../../../assets/icons/secureProxy_blue.svg" alt="">
  <div
  class="w-full h-full flex flex-col justify-center lg:items-start items-center sm:px-[40px] p-[20px] gap-[40px]"
>
 <div class="w-full flex justify-between justify-center items-center">
  <div class="flex w-full flex-col gap-[5px]">
    <span class="text-[28px] font-[700]">Welcome Back!</span>
    <span class="text-[14px] text-slate-500 font-[600]">{{OTPState ? 'Enter you Login Details' : 'Enter the OTP Sent'}}</span>
  </div>
  <div *ngIf="OTPState" class="flex gap-[5px] w-fit items-center cursor-pointer" (click)="signIn()">
    <img class="w-[15px]" src="../../../assets/icons/refresh.svg" alt="">
    <span class="text-[12px] font-[400] whitespace-nowrap">Resend OTP</span>
  </div>
 </div>
  <div class="flex flex-col w-full gap-[10px]">
    <div class="flex flex-col w-full">
          <div *ngIf="!OTPState" class="w-full flex flex-col">
            <app-input
            [label]="'Email Address'"
            [placeholder]="'Enter email address'"
            [title]="'emailAddress'"
            (returnValue)="handleInput($event)"
            [error]="errors.emailAddress"
          ></app-input>
          <app-input
            [label]="'Password'"
            [placeholder]="'Enter password'"
            [title]="'password'"
            [type]="'password'"
            (returnValue)="handleInput($event)"
            [error]="errors.password"
          ></app-input>
          </div>
          <div *ngIf="OTPState" class="mb-[30px]">
            <app-otp-field (OTPReturnValue)="setOTP($event)" [error]="errors.otp" />
          </div>
      <app-button
        [label]="OTPState ? 'Send OTP' : 'Sign In'"
        [loading]="loading"
        (onClick)="OTPState ? verifyOTP() : signIn()"
        [className]="
          'text-[#fff] w-full h-[50px] flex items-center whitespace-nowrap justify-center cursor-pointer rounded-[5px] bg-[#081A46]'
        "
      ></app-button>
    </div>
    <div class="w-full flex justify-start">
      <span class="text-[12px] font-[500]"
        >Don't have an account?
        <span (click)="routeTo('register')" class="font-[600] cursor-pointer text-slate-500"
          >Register</span
        ></span
      >
    </div>
  </div>
</div>
 </div>
</div>







<!-- <div class="w-full h-[100vh] flex md:grid md:grid-cols-[55%,_1fr]">
  <div class="w-full hidden h-full lg:flex flex-col p-[35px]" style="background-image: url(../../../assets/images/card-bg-center.png); background-position: center; background-repeat: no-repeat; background-size: cover;">
    <div class="w-full hidden h-full md:grid flex-col grid grid-rows-[5%_1fr_5%]">
    <img class="max-w-[180px]" src="../../../assets/icons/secureProxy_white.svg" alt="" />
   <div class="w-full h-full flex justify-center items-end">
   </div>
    <div class="w-full flex">
      <div class="typing-effect ">
        {{ currentText }}<span class="cursor">|</span>
      </div>
    </div>
  </div></div>
 <div class="w-full flex flex-col">
   <img class="max-w-[130px] ms-[40px] mt-[40px] md:hidden flex " src="../../../assets/icons/secureProxy_blue.svg" alt="">
  <div
  class="w-full h-full flex flex-col justify-center lg:items-start items-center sm:px-[40px] p-[20px] gap-[40px]"
>
 <div class="w-full flex justify-between justify-center items-center">
  <div class="flex w-full flex-col gap-[5px]">
    <span class="text-[28px] font-[700]">Welcome Back!</span>
    <span class="text-[14px] text-slate-500 font-[600]">{{OTPState ? 'Enter you Login Details' : 'Enter the OTP Sent'}}</span>
  </div>
  <div *ngIf="OTPState" class="flex gap-[5px] w-fit items-center cursor-pointer" (click)="signIn()">
    <img class="w-[15px]" src="../../../assets/icons/refresh.svg" alt="">
    <span class="text-[12px] font-[400] whitespace-nowrap">Resend OTP</span>
  </div>
 </div>
  <div class="flex flex-col w-full gap-[10px]">
    <div class="flex flex-col w-full">
          <div *ngIf="!OTPState" class="w-full flex flex-col">
            <app-input
            [label]="'Email Address'"
            [placeholder]="'Enter email address'"
            [title]="'emailAddress'"
            (returnValue)="handleInput($event)"
            [error]="errors.emailAddress"
          ></app-input>
          <app-input
            [label]="'Password'"
            [placeholder]="'Enter password'"
            [title]="'password'"
            [type]="'password'"
            (returnValue)="handleInput($event)"
            [error]="errors.password"
          ></app-input>
          </div>
          <div *ngIf="OTPState" class="mb-[30px]">
            <app-otp-field (OTPReturnValue)="setOTP($event)" [error]="errors.otp" />
          </div>
      <app-button
        [label]="OTPState ? 'Send OTP' : 'Sign In'"
        [loading]="loading"
        (onClick)="OTPState ? verifyOTP() : signIn()"
        [className]="
          'text-[#fff] w-full h-[50px] flex items-center whitespace-nowrap justify-center cursor-pointer rounded-[5px] bg-[#081A46]'
        "
      ></app-button>
    </div>
    <div class="w-full flex justify-start">
      <span class="text-[12px] font-[500]"
        >Don't have an account?
        <span (click)="routeTo('register')" class="font-[600] cursor-pointer text-slate-500"
          >Register</span
        ></span
      >
    </div>
  </div>
</div>
 </div>
</div> -->
